module.exports = __webpack_public_path__ + "img/视频封面19.3d8af99d.png";